import ExportedImage from 'next-image-export-optimizer';
import React from 'react';
import { getAccentTextColor, getBorderAccentColor, type ColorType } from '../../../../styles/Color';
import styles from './circle-image-with-link.module.scss';

export type CircleImageWithLinkProps = {
  label: string;
  href: string;
  imageSrc: string;
  color: ColorType;
  imageAlt?: string;
};

export const CircleImageWithLink = ({ label, href, imageSrc, color, imageAlt = '' }: CircleImageWithLinkProps) => {
  const cssVars = {
    '--circle-color': color,
    '--label-color': getAccentTextColor(color),
    '--circle-border-color': getBorderAccentColor(color),
  } as React.CSSProperties;

  return (
    <a href={href} className={styles['link-base']} style={cssVars}>
      <div className={styles['image-wrapper']}>
        <ExportedImage fill className={styles.image} src={imageSrc} alt={imageAlt} loading="lazy" />
      </div>
      <div className={styles['label-wrapper']}>{label}</div>
    </a>
  );
};
